module.exports = __webpack_public_path__ + "static/media/account.763388dd.svg";